package com.iregained.site.pages

import androidx.compose.runtime.Composable
import com.iregained.site.components.layouts.PageLayout
import com.iregained.site.components.sections.error.NotFoundSection
import com.varabyte.kobweb.core.Page

@Page(routeOverride = "404")
@Composable
fun NotFoundPage() {
    PageLayout {
        NotFoundSection()
    }
}

// 2. CLIENT-SIDE FALLBACK
// Catch-all route that intercepts broken internal links (like /contact11)
@Page(routeOverride = "{...catchall}")
@Composable
fun CatchAllPage() {
    // We simply render the exact same UI
    NotFoundPage()
}